import { render, staticRenderFns } from "./C-3e-1c__ProductList_Dialog-with-DropZone_3-fileAttached.vue?vue&type=template&id=6af6a354&"
import script from "./C-3e-1c__ProductList_Dialog-with-DropZone_3-fileAttached.vue?vue&type=script&lang=js&"
export * from "./C-3e-1c__ProductList_Dialog-with-DropZone_3-fileAttached.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
